export function getApiBaseUrl(envVarName: string): string {
  const url = process.env[envVarName];
  if (!url) {
    throw new Error(`Environment variable ${envVarName} is not set`);
  }
  return url;
}